import { NavigationData } from 'core/slices/models';

export function hasGridReportId(
  navData: NavigationData,
  selectedReport: string
) {
  const search = nodes =>
    nodes?.some(
      node =>
        node.id === selectedReport || (node.children && search(node.children))
    );
  return search(navData.children);
}
